<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7Je9a9/tc-custom/9781328561008.jpg?1701346981337" alt="This image is the cover for the book Lyric McKerrigan, Secret Librarian"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lyric McKerrigan, Secret Librarian
      </h1>
      <p class="bookDescription body article font2">
        <b>“</b><b>What if there were a superhero who could give people in trouble the very book they need most?...[A] winning concept…cheeky hilarity.”—<i>Publishers Weekly</i></b><br/>  <br/> A super-secret operative saves the world from a diabolical threat through her ability to brandish just the right book at just the right time in this delightfully silly superhero tale illustrated by an Eisner Award-winner and Caldecott Honoree.<br/>  <br/> When an evil genius has a diabolical plan to destroy every book on the planet, who has the tome-toting page power to thwart his dastardly scheme? Lyric McKerrigan, Secret Librarian! She’s got the gadgets. She’s got the disguises. And she’s always got the right book at the right time. It’s a good thing, too, because Lyric McKerrigan is the world’s last hope! With lots of humor and a “thrilling, action-packed pace” (<i>Horn Book Magazine</i>), Jacob Sager Weinstein and Vera Brosgol introduce a smart and crafty heroine who is part comic-book hero, part reader extraordinaire, and wholly awesome.<br/>  <br/> “An exciting escapade with an unlikely hero and a not-so-secret message about the power of books.”—<i>Kirkus Reviews</i><br/><br/> “Sure to delight budding comic fans, crime fighters, and bibliophiles alike.”—<i>School Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacob Sager Weinstein, Vera Brosgol
      </h2>
      
      <p class="authorDescription body article">Jacob Sager Weinstein has been published in The New Yorker, McSweeney's, and Self and is a former contributor to The Onion. In addition to writing satirical books for adults, he enjoys writing middle-grade fiction. He currently resides in London. For more information, visit him at jacobsagerweinstein.com or on Twitter at @jacobsw.A diverse cast of individuals worked together to achieve the brilliant sound and performances contained in this audiobook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68bda6d7